import { endpoint } from "views/pages/manage/common/constant";

import { updateRequest } from "views/pages/manage/edpOps/constant/common";
import { fetchAllPostPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { getAllActivePaymentMode } from "../../../../unAssigned/studentFinanceApproval/epmrCancellation/utils";

export const emptySearchFields = {
  psid: "",
  studentName: "",
};

export const statusDropdown = [
  { label: "Pending", value: "NEW" },
  { label: "Waiting for L1 approval", value: "PENDING" },
  { label: "Waiting for L2 approval", value: "L1_APPROVED" },
  { label: "Confirmed", value: "CONFIRMED" },
  { label: "Receipted", value: "RECEIPTED" },
];

export const getReceiptsList = async ({ payload = {}, page = 0 }) => {
  const requestPayload = updateRequest(payload);
  const response = await fetchAllPostPromisedData(
    `${endpoint.epmrReceipt.search}?offset=${page}`,
    {
      ...requestPayload,
      // Pending means status: "NEW", "L1_REJECT", "L2_REJECT"
      ...(requestPayload?.status?.includes("NEW") && {
        status: [...requestPayload.status, "L1_REJECT", "L2_REJECT"],
      }),
    },
    "post"
  );

  return response;
};

export const getDropdowns = async () => {
  const paymode = await getAllActivePaymentMode();

  return {
    paymode,
  };
};

export const isFilterApplied = (form) => {
  let count = 0;
  const valueList = Object.values(form);
  for (let item in valueList) {
    if (Array.isArray(valueList[item]) && valueList[item].length > 0) count++;
    if (!Array.isArray(valueList[item]) && valueList[item]) count++;
  }
  return count;
};

export const epmrStatusChipInfo = {
  "Confirmed": { text: "Confirmed", textColor: "##0B442D", bgColor: "#BBE2CE" },
  "Cancelled": { text: "Cancelled", textColor: "#B32306", bgColor: "#F9D9D7" },
  "Not Confirmed": {
    text: "Not Confirmed",
    textColor: "#705010",
    bgColor: "#FFEDC8",
  },
  // "OVERDUE" : {text: <span className="cursor">Overdue <InfoIcon/></span>, textColor: "#B32306", bgColor: "#F9D9D7" },
};